import KeyResourceContent from '../function-components/KeyResourceContent'

function KeyResource(){
    return (        
        <KeyResourceContent />
    )
}

export default KeyResource;